import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '@standardnotes/snjs';
const Checkbox = ({ name, checked, onChange, disabled, label }) => {
    return (_jsxs("label", { htmlFor: name, className: classNames('fit-content mb-2 flex items-center text-sm', disabled ? 'cursor-not-allowed' : 'cursor-pointer'), children: [_jsx("input", { className: classNames('mr-2', disabled ? 'cursor-not-allowed' : 'cursor-pointer'), type: "checkbox", name: name, id: name, checked: checked, onChange: onChange, disabled: disabled }), label] }));
};
export default Checkbox;
